import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20d71a7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table table-bordered" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"50%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"25%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"25%"} })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "科目"),
    /*#__PURE__*/_createElementVNode("th", { colspan: "2" }, "金額")
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, "事業損益"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "本来業務事業損益"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "事業収益", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_8 = { class: "text-right" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "事業費用"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-3" }, "事業費", -1))
const _hoisted_11 = { class: "text-right" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-3" }, "本部費", -1))
const _hoisted_14 = { class: "text-right" }
const _hoisted_15 = { class: "text-right" }
const _hoisted_16 = { class: "indent-4" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_18 = { class: "text-right" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "附帯業務事業損益"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td")
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "事業収益", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_22 = { class: "text-right" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "事業費用", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_25 = { class: "text-right" }
const _hoisted_26 = { class: "indent-4" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_28 = { class: "text-right" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", { class: "indent-1" }, "収益業務事業損益"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td")
], -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "事業収益", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_32 = { class: "text-right" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-2" }, "事業費用", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_35 = { class: "text-right" }
const _hoisted_36 = { class: "indent-4" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_38 = { class: "text-right" }
const _hoisted_39 = { class: "text-right ls-wider font-weight-bold" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_41 = { class: "text-right" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, "事業外収益"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td")
], -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-3" }, "受取利息", -1))
const _hoisted_44 = { class: "text-right" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-3" }, "その他の事業外収益", -1))
const _hoisted_47 = { class: "text-right" }
const _hoisted_48 = { class: "text-right" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, "事業外費用"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td")
], -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-3" }, "支払利息", -1))
const _hoisted_51 = { class: "text-right" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-3" }, "その他の事業外費用", -1))
const _hoisted_54 = { class: "text-right" }
const _hoisted_55 = { class: "text-right" }
const _hoisted_56 = { class: "text-right ls-wider font-weight-bold" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_58 = { class: "text-right" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, "特別利益"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td")
], -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-3" }, "固定資産売却益", -1))
const _hoisted_61 = { class: "text-right" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-3" }, "その他の特別利益", -1))
const _hoisted_64 = { class: "text-right" }
const _hoisted_65 = { class: "text-right" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", null, "特別損失"),
  /*#__PURE__*/_createElementVNode("td"),
  /*#__PURE__*/_createElementVNode("td")
], -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-3" }, "固定資産売却損", -1))
const _hoisted_68 = { class: "text-right" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "indent-3" }, "その他の特別損失", -1))
const _hoisted_71 = { class: "text-right" }
const _hoisted_72 = { class: "text-right" }
const _hoisted_73 = { class: "text-right ls-wider font-weight-bold" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_75 = { class: "text-right" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-right ls-wider" }, "法人税・住民税及び事業税", -1))
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_78 = { class: "text-right" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-right ls-wider" }, "法人税等調整額", -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_81 = { class: "text-right" }
const _hoisted_82 = { class: "text-right ls-wider font-weight-bold" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_84 = { class: "text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_kin = _resolveComponent("input-kin")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("table", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("tbody", null, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("tr", null, [
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("td", _hoisted_8, [
            _createVNode(_component_input_kin, {
              modelValue: _ctx.honraiJigyoShueki.kin,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.honraiJigyoShueki.kin) = $event)),
              "allow-blank": true,
              min: 0,
              disabled: _ctx.isDisabledByCorporationType(_ctx.honraiJigyoShueki)
            }, null, 8, ["modelValue", "disabled"])
          ])
        ]),
        _hoisted_9,
        _createElementVNode("tr", null, [
          _hoisted_10,
          _createElementVNode("td", _hoisted_11, [
            _createVNode(_component_input_kin, {
              modelValue: _ctx.honraiJigyohi.kin,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.honraiJigyohi.kin) = $event)),
              "allow-blank": true,
              min: 0,
              disabled: _ctx.isDisabledByCorporationType(_ctx.honraiJigyohi)
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _hoisted_12
        ]),
        _createElementVNode("tr", null, [
          _hoisted_13,
          _createElementVNode("td", _hoisted_14, [
            _createVNode(_component_input_kin, {
              modelValue: _ctx.honraiHonbuhi.kin,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.honraiHonbuhi.kin) = $event)),
              "allow-blank": true,
              min: 0,
              disabled: _ctx.isDisabledByCorporationType(_ctx.honraiHonbuhi)
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _createElementVNode("td", _hoisted_15, [
            _createVNode(_component_input_kin, {
              modelValue: _ctx.honraiJigyoHiyo.kin,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.honraiJigyoHiyo.kin) = $event)),
              "allow-blank": true,
              min: 0,
              disabled: _ctx.isDisabledByCorporationType(_ctx.honraiJigyoHiyo)
            }, null, 8, ["modelValue", "disabled"])
          ])
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_16, "本来業務事業" + _toDisplayString(_ctx.getRiekiOrSonsitsuLabel(_ctx.honraiRieki.kin)), 1),
          _hoisted_17,
          _createElementVNode("td", _hoisted_18, [
            _createVNode(_component_input_kin, {
              modelValue: _ctx.honraiRieki.kin,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.honraiRieki.kin) = $event)),
              "allow-blank": true,
              disabled: _ctx.isDisabledByCorporationType(_ctx.honraiRieki)
            }, null, 8, ["modelValue", "disabled"])
          ])
        ]),
        _hoisted_19,
        _createElementVNode("tr", null, [
          _hoisted_20,
          _hoisted_21,
          _createElementVNode("td", _hoisted_22, [
            _createVNode(_component_input_kin, {
              modelValue: _ctx.futaiJigyoShueki.kin,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.futaiJigyoShueki.kin) = $event)),
              "allow-blank": true,
              min: 0,
              disabled: _ctx.isDisabledByCorporationType(_ctx.futaiJigyoShueki)
            }, null, 8, ["modelValue", "disabled"])
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_23,
          _hoisted_24,
          _createElementVNode("td", _hoisted_25, [
            _createVNode(_component_input_kin, {
              modelValue: _ctx.futaiJigyoHiyo.kin,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.futaiJigyoHiyo.kin) = $event)),
              "allow-blank": true,
              min: 0,
              disabled: _ctx.isDisabledByCorporationType(_ctx.futaiJigyoHiyo)
            }, null, 8, ["modelValue", "disabled"])
          ])
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_26, "附帯業務事業" + _toDisplayString(_ctx.getRiekiOrSonsitsuLabel(_ctx.futaiRieki.kin)), 1),
          _hoisted_27,
          _createElementVNode("td", _hoisted_28, [
            _createVNode(_component_input_kin, {
              modelValue: _ctx.futaiRieki.kin,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.futaiRieki.kin) = $event)),
              "allow-blank": true,
              disabled: _ctx.isDisabledByCorporationType(_ctx.futaiRieki)
            }, null, 8, ["modelValue", "disabled"])
          ])
        ]),
        _hoisted_29,
        _createElementVNode("tr", null, [
          _hoisted_30,
          _hoisted_31,
          _createElementVNode("td", _hoisted_32, [
            _createVNode(_component_input_kin, {
              modelValue: _ctx.shuekiJigyoShueki.kin,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.shuekiJigyoShueki.kin) = $event)),
              "allow-blank": true,
              min: 0,
              disabled: _ctx.isDisabledByCorporationType(_ctx.shuekiJigyoShueki)
            }, null, 8, ["modelValue", "disabled"])
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_33,
          _hoisted_34,
          _createElementVNode("td", _hoisted_35, [
            _createVNode(_component_input_kin, {
              modelValue: _ctx.shuekiJigyoHiyo.kin,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.shuekiJigyoHiyo.kin) = $event)),
              "allow-blank": true,
              min: 0,
              disabled: _ctx.isDisabledByCorporationType(_ctx.shuekiJigyoHiyo)
            }, null, 8, ["modelValue", "disabled"])
          ])
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_36, "収益業務事業" + _toDisplayString(_ctx.getRiekiOrSonsitsuLabel(_ctx.shuekiRieki.kin)), 1),
          _hoisted_37,
          _createElementVNode("td", _hoisted_38, [
            _createVNode(_component_input_kin, {
              modelValue: _ctx.shuekiRieki.kin,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.shuekiRieki.kin) = $event)),
              "allow-blank": true,
              disabled: _ctx.isDisabledByCorporationType(_ctx.shuekiRieki)
            }, null, 8, ["modelValue", "disabled"])
          ])
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_39, "事業" + _toDisplayString(_ctx.getRiekiOrSonsitsuLabel(_ctx.jigyoRieki.kin)), 1),
          _hoisted_40,
          _createElementVNode("td", _hoisted_41, [
            _createVNode(_component_input_kin, {
              modelValue: _ctx.jigyoRieki.kin,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.jigyoRieki.kin) = $event)),
              "allow-blank": true,
              disabled: _ctx.isDisabledByCorporationType(_ctx.jigyoRieki)
            }, null, 8, ["modelValue", "disabled"])
          ])
        ]),
        _hoisted_42,
        _createElementVNode("tr", null, [
          _hoisted_43,
          _createElementVNode("td", _hoisted_44, [
            _createVNode(_component_input_kin, {
              modelValue: _ctx.uketoriRisoku.kin,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.uketoriRisoku.kin) = $event)),
              "allow-blank": true,
              disabled: _ctx.isDisabledByCorporationType(_ctx.uketoriRisoku)
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _hoisted_45
        ]),
        _createElementVNode("tr", null, [
          _hoisted_46,
          _createElementVNode("td", _hoisted_47, [
            _createVNode(_component_input_kin, {
              modelValue: _ctx.otherJigyoGaiShueki.kin,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.otherJigyoGaiShueki.kin) = $event)),
              "allow-blank": true,
              disabled: _ctx.isDisabledByCorporationType(_ctx.otherJigyoGaiShueki)
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _createElementVNode("td", _hoisted_48, [
            _createVNode(_component_input_kin, {
              modelValue: _ctx.JigyoGaiShueki.kin,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.JigyoGaiShueki.kin) = $event)),
              "allow-blank": true,
              min: 0,
              disabled: _ctx.isDisabledByCorporationType(_ctx.JigyoGaiShueki)
            }, null, 8, ["modelValue", "disabled"])
          ])
        ]),
        _hoisted_49,
        _createElementVNode("tr", null, [
          _hoisted_50,
          _createElementVNode("td", _hoisted_51, [
            _createVNode(_component_input_kin, {
              modelValue: _ctx.shiharaiRisoku.kin,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.shiharaiRisoku.kin) = $event)),
              "allow-blank": true,
              disabled: _ctx.isDisabledByCorporationType(_ctx.shiharaiRisoku)
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _hoisted_52
        ]),
        _createElementVNode("tr", null, [
          _hoisted_53,
          _createElementVNode("td", _hoisted_54, [
            _createVNode(_component_input_kin, {
              modelValue: _ctx.otherJigyoGaiHiyo.kin,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.otherJigyoGaiHiyo.kin) = $event)),
              "allow-blank": true,
              disabled: _ctx.isDisabledByCorporationType(_ctx.otherJigyoGaiHiyo)
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _createElementVNode("td", _hoisted_55, [
            _createVNode(_component_input_kin, {
              modelValue: _ctx.jigyoGaiHiyo.kin,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.jigyoGaiHiyo.kin) = $event)),
              min: 0,
              "allow-blank": true,
              disabled: _ctx.isDisabledByCorporationType(_ctx.jigyoGaiHiyo)
            }, null, 8, ["modelValue", "disabled"])
          ])
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_56, "経常" + _toDisplayString(_ctx.getRiekiOrSonsitsuLabel(_ctx.keijoRieki.kin)), 1),
          _hoisted_57,
          _createElementVNode("td", _hoisted_58, [
            _createVNode(_component_input_kin, {
              modelValue: _ctx.keijoRieki.kin,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.keijoRieki.kin) = $event)),
              "allow-blank": true,
              disabled: _ctx.isDisabledByCorporationType(_ctx.keijoRieki)
            }, null, 8, ["modelValue", "disabled"])
          ])
        ]),
        _hoisted_59,
        _createElementVNode("tr", null, [
          _hoisted_60,
          _createElementVNode("td", _hoisted_61, [
            _createVNode(_component_input_kin, {
              modelValue: _ctx.koteiShisanBaikyakuEki.kin,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.koteiShisanBaikyakuEki.kin) = $event)),
              "allow-blank": true,
              disabled: _ctx.isDisabledByCorporationType(_ctx.koteiShisanBaikyakuEki)
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _hoisted_62
        ]),
        _createElementVNode("tr", null, [
          _hoisted_63,
          _createElementVNode("td", _hoisted_64, [
            _createVNode(_component_input_kin, {
              modelValue: _ctx.otherTokubetsuRieki.kin,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.otherTokubetsuRieki.kin) = $event)),
              "allow-blank": true,
              disabled: _ctx.isDisabledByCorporationType(_ctx.otherTokubetsuRieki)
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _createElementVNode("td", _hoisted_65, [
            _createVNode(_component_input_kin, {
              modelValue: _ctx.tokubetsuRieki.kin,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.tokubetsuRieki.kin) = $event)),
              "allow-blank": true,
              min: 0,
              disabled: _ctx.isDisabledByCorporationType(_ctx.tokubetsuRieki)
            }, null, 8, ["modelValue", "disabled"])
          ])
        ]),
        _hoisted_66,
        _createElementVNode("tr", null, [
          _hoisted_67,
          _createElementVNode("td", _hoisted_68, [
            _createVNode(_component_input_kin, {
              modelValue: _ctx.koteiShisanBaikyakuSon.kin,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.koteiShisanBaikyakuSon.kin) = $event)),
              "allow-blank": true,
              disabled: _ctx.isDisabledByCorporationType(_ctx.koteiShisanBaikyakuSon)
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _hoisted_69
        ]),
        _createElementVNode("tr", null, [
          _hoisted_70,
          _createElementVNode("td", _hoisted_71, [
            _createVNode(_component_input_kin, {
              modelValue: _ctx.otherTokubetsuSonShitsu.kin,
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.otherTokubetsuSonShitsu.kin) = $event)),
              "allow-blank": true,
              disabled: _ctx.isDisabledByCorporationType(_ctx.otherTokubetsuSonShitsu)
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _createElementVNode("td", _hoisted_72, [
            _createVNode(_component_input_kin, {
              modelValue: _ctx.tokubetsuSonshitsu.kin,
              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.tokubetsuSonshitsu.kin) = $event)),
              "allow-blank": true,
              min: 0,
              disabled: _ctx.isDisabledByCorporationType(_ctx.tokubetsuSonshitsu)
            }, null, 8, ["modelValue", "disabled"])
          ])
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_73, "税引前当期純" + _toDisplayString(_ctx.getRiekiOrSonsitsuLabel(_ctx.zeibikiMaeTokiJunRieki.kin)), 1),
          _hoisted_74,
          _createElementVNode("td", _hoisted_75, [
            _createVNode(_component_input_kin, {
              modelValue: _ctx.zeibikiMaeTokiJunRieki.kin,
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.zeibikiMaeTokiJunRieki.kin) = $event)),
              "allow-blank": true,
              disabled: _ctx.isDisabledByCorporationType(_ctx.zeibikiMaeTokiJunRieki)
            }, null, 8, ["modelValue", "disabled"])
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_76,
          _hoisted_77,
          _createElementVNode("td", _hoisted_78, [
            _createVNode(_component_input_kin, {
              modelValue: _ctx.hojinJuminJigyoZei.kin,
              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.hojinJuminJigyoZei.kin) = $event)),
              "allow-blank": true,
              min: 0,
              disabled: _ctx.isDisabledByCorporationType(_ctx.hojinJuminJigyoZei)
            }, null, 8, ["modelValue", "disabled"])
          ])
        ]),
        _createElementVNode("tr", null, [
          _hoisted_79,
          _hoisted_80,
          _createElementVNode("td", _hoisted_81, [
            _createVNode(_component_input_kin, {
              modelValue: _ctx.hojinZeiChosei.kin,
              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.hojinZeiChosei.kin) = $event)),
              "allow-blank": true,
              disabled: _ctx.isDisabledByCorporationType(_ctx.hojinZeiChosei)
            }, null, 8, ["modelValue", "disabled"])
          ])
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_82, "当期純" + _toDisplayString(_ctx.getRiekiOrSonsitsuLabel(_ctx.tokiJunRieki.kin)), 1),
          _hoisted_83,
          _createElementVNode("td", _hoisted_84, [
            _createVNode(_component_input_kin, {
              modelValue: _ctx.tokiJunRieki.kin,
              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.tokiJunRieki.kin) = $event)),
              "allow-blank": true,
              disabled: _ctx.isDisabledByCorporationType(_ctx.tokiJunRieki)
            }, null, 8, ["modelValue", "disabled"])
          ])
        ])
      ])
    ])
  ]))
}